(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wondercide-delivery-estimator"] && !Shopify.designMode) return;
  try {
    (() => {
  const main = document.getElementById('MainContent');
  if (!main || !main.dataset.template?.startsWith('product')) return;
  let scheduled = false;
  let focusZip = false;
  const boundInputs = new WeakSet();
  const boundSubmits = new WeakSet();
  const resetSelector = '.estimator-zipcode-message-reset';
  function enhance() {
    scheduled = false;
    main.querySelectorAll('.estimator-message').forEach((widget) => {
      widget.querySelectorAll('.estimator-zipcode-message').forEach((line) => {
        const reset = line.querySelector(resetSelector);
        if (!reset || line.querySelector('.wc-delivery-change-zip')) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'wc-delivery-change-zip';
        button.textContent = 'change ZIP';
        button.setAttribute('aria-label', 'Change delivery ZIP code');
        button.addEventListener('click', () => {
          focusZip = true;
          reset.dispatchEvent(new MouseEvent('click', { bubbles: true }));
          schedule();
        });
        line.append(button);
      });
      widget.querySelectorAll('.wondercide-delivery-message strong').forEach((date) => {
        const text = date.textContent.trim();
        const match = text.match(/^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), ([A-Za-z]+) ([0-9]{1,2})$/);
        if (!match) return;
        const day = Number(match[3]);
        const suffix = day % 100 >= 11 && day % 100 <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
        date.textContent = text + suffix;
      });
      const input = widget.querySelector('.estimator-zipcode input');
      const submit = widget.querySelector('.estimator-zipcode-submit');
      if (submit && !boundSubmits.has(submit)) {
        boundSubmits.add(submit);
        submit.setAttribute('role', 'button');
        submit.setAttribute('tabindex', '0');
        submit.setAttribute('aria-label', 'Update delivery ZIP code');
        submit.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          event.stopPropagation();
          submit.click();
        });
      }
      if (input) {
        if (!boundInputs.has(input)) {
          boundInputs.add(input);
          input.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter') return;
            event.preventDefault();
            event.stopPropagation();
            widget.querySelector('.estimator-zipcode-submit')?.click();
          });
        }
        if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', 'Delivery ZIP code');
        input.setAttribute('inputmode', 'numeric');
        input.setAttribute('autocomplete', 'postal-code');
        if (focusZip && input.getClientRects().length) {
          focusZip = false;
          input.focus();
          input.select();
        }
      }
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(enhance);
  }
  new MutationObserver(schedule).observe(main, { childList: true, subtree: true, characterData: true });
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();
  } catch(e) { console.error(e); }
})();

})();
